import { render, staticRenderFns } from "./DeviceEditModal.vue?vue&type=template&id=124c49a6&"
import script from "./DeviceEditModal.vue?vue&type=script&lang=ts&"
export * from "./DeviceEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports